const ESTATUS_ENUM = Object.freeze({
  vehicle: Object.freeze({
    ACTIVO: Object.freeze({ type: "finalizado", label: "Activo" }),
    INACTIVO: Object.freeze({ type: "cancelado", label: "Inactivo" }),
  }),
  warehouse: Object.freeze({
    PROPIO: Object.freeze({ type: "finalizado", label: "Propio" }),
    EXTERNO: Object.freeze({ type: "pendiente", label: "Externo" }),
  }),
  user: Object.freeze({
    ACTIVED: Object.freeze({ type: "finalizado", label: "Activo" }),
    INACTIVED: Object.freeze({ type: "cancelado", label: "Inactivo" }),
  }),
  stop: Object.freeze({
    NO_ASIGNADA: Object.freeze({ type: "pendiente", label: "No asignada" }),
    ASIGNADA: Object.freeze({ type: "en_curso", label: "Asignada" }),
    FINALIZADO: Object.freeze({ type: "finalizado", label: "Finalizado" }),
    FINALIZADO_PARCIAL: Object.freeze({ type: "incidencia", label: "Parcial" }),
    INCIDENCIA: Object.freeze({ type: "incidencia", label: "Incidencia" }),
    CANCELADA: Object.freeze({ type: "cancelado", label: "Excluida" }),
  }),
  plan: Object.freeze({
    PENDIENTE: Object.freeze({ type: "pendiente", label: "Borrador" }),
    EN_CURSO: Object.freeze({ type: "en_curso", label: "En ruta" }),
    FINALIZADO: Object.freeze({ type: "finalizado", label: "Finalizado" }),
  }),
  route: Object.freeze({
    PENDIENTE: Object.freeze({ type: "pendiente", label: "Pendiente" }),
    EN_CURSO: Object.freeze({ type: "en_curso", label: "En ruta" }),
    FINALIZADO: Object.freeze({ type: "finalizado", label: "Finalizado" }),
  }),
  route_stop: Object.freeze({
    PENDIENTE: Object.freeze({ type: "pendiente", label: "Pendiente" }),
    INCIDENCIA: Object.freeze({ type: "incidencia", label: "Incidencia" }),
    FINALIZADO: Object.freeze({ type: "finalizado", label: "Finalizado" }),
    FINALIZADO_PARCIAL: Object.freeze({ type: "incidencia", label: "Parcial" }),
  }),
  task: Object.freeze({
    PENDIENTE: Object.freeze({ type: "pendiente", label: "Pendiente" }),
    INCIDENCIA: Object.freeze({ type: "incidencia", label: "Incidencia" }),
    FINALIZADO: Object.freeze({ type: "finalizado", label: "Finalizado" }),
    ANULADO: Object.freeze({ type: "cancelado", label: "Anulado" }),
  }),
  sla: Object.freeze({
    OK: Object.freeze({ type: "finalizado", label: "OK" }),
    ALERTA: Object.freeze({ type: "incidencia", label: "Alerta" }),
    WARNING: Object.freeze({ type: "incidencia", label: "Warning" }),
    WARN: Object.freeze({ type: "incidencia", label: "Warn" }),
  }),
});

export default ESTATUS_ENUM;
